import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDPrimaryActionButton, FDPrimaryActionIconButton, FDStack } from '@facet-wealth/design';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { dataAttrs } from 'Helpers/Testing';

const Layout = () => {
  const { onSubmit, saving, resource } = useMetaLayoutContext();
  const expenseGroups = ['housingExpenses', 'livingExpenses', 'transportationExpenses'];
  const { loadModalCollectionByLink } = useModalContext();
  return (
    <>
      <MetaControlField attr="title" />
      <DialogContent>
        <FDStack direction="column" spacing={2}>
          <MetaControlField attr="description" />
          {expenseGroups.map(group => <MetaControlField key={group} attr={group} CustomProps={{ label: resource.metaField(group).attr('prompt') }} />)}
          <MetaLayoutRemainingFields />
        </FDStack>
      </DialogContent>
      <DialogActions>
        {resource.withRelationship(fr.relationships.previousLink.name,
          (rel) => (
            <FDPrimaryActionIconButton
              icon="chevronLeft"
              onClick={() => {
                loadModalCollectionByLink(rel.link('related').url());
              }}
            />
          ),
          () => null)}
        <FDPrimaryActionButton {...dataAttrs('continue-btn', resource)} label="Continue →" onClick={onSubmit} disabled={saving} />
      </DialogActions>
    </>
  );
};

export default Layout;
